import { useQuery } from "@tanstack/react-query";
import { useRuntime } from "../runtime/RuntimeContext";

export function useMe() {
    const runtime = useRuntime();
    return useQuery({ queryKey: ["me"], queryFn: () => runtime.services.auth.me() });
}

export function useBootstrap() {
    const runtime = useRuntime();
    return useQuery({ queryKey: ["bootstrap"], queryFn: () => runtime.services.bootstrap.bootstrap() });
}
